/**
 * Patterns that indicate the Star printer's connection port is occupied by
 * another client. Observed in production logs from both Android and iOS
 * native plugins, surfaced via the message of `StarIOPortException` /
 * `SMPortException`.
 *
 * Kept as a single source of truth so adjustments do not leak into the
 * printer service itself.
 */
const STAR_BUSY_MESSAGE_PATTERNS: ReadonlyArray<RegExp> = [
  /port.*busy/i,
  /\bEBUSY\b/i,
  /already in use/i,
  /\bin use\b/i,
];

/**
 * Returns true when the given error originates from the Star plugin and
 * represents a transient "port busy" condition that warrants a backoff
 * retry rather than treating the print as failed.
 */
export function isStarBusyError(error: unknown): boolean {
  const message =
    typeof error === 'object' && error !== null && 'message' in error
      ? String((error as { message?: unknown }).message ?? '')
      : String(error ?? '');

  if (!message) return false;

  return STAR_BUSY_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
}
